import {
  USER_SEARCH, USER_SEARCH_SUCCESS, USER_SEARCH_FAILURE, USER_CLEAR, USER_SEARCH_AUTOCOMPLETE_SUCCESS, USER_AUTOCOMPLETE_CLEAR,
  USER_ADMIN_PHARMACIST, USER_ADMIN_PHARMACIST_SUCCESS, USER_ADMIN_PHARMACIST_FAILURE
} from './mutation-types'

export default {
  state: {
    users: [],
    usersAutocomplete: null,
    usersNextPage: 1,
    userAdmin: false,                    // システム管理者
    userPharmacist: false,               // 薬剤師
    userPharmacistManager: false,        // 組織長かつ薬剤師
    userAdminOrPharmacist: false,        // システム管理者 または 薬剤師
    userAdminOrPharmacistManager: false, // システム管理者 または 組織長かつ薬剤師
    userAdminOrPharmacistId: null,       // システム管理者 または 薬剤師 ユーザーID
    userAdminOrPharmacistName: null      // システム管理者 または 薬剤師 ユーザー名
  },
  getters: {
    users: state => {
      return state.users
    },
    usersAutocomplete: state => {
      return state.usersAutocomplete
    },
    usersNextPage: state => {
      return state.usersNextPage
    },
    userAdmin: state => {
      return state.userAdmin
    },
    userPharmacist: state => {
      return state.userPharmacist
    },
    userPharmacistManager: state => {
      return state.userPharmacistManager
    },
    userAdminOrPharmacist: state => {
      return state.userAdminOrPharmacist
    },
    userAdminOrPharmacistManager: state => {
      return state.userAdminOrPharmacistManager
    },
    userAdminOrPharmacistId: state => {
      return state.userAdminOrPharmacistId
    },
    userAdminOrPharmacistName: state => {
      return state.userAdminOrPharmacistName
    }
  },
  actions: {
    [USER_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      var autocomplete = false
      var noneList = null
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('autocomplete' in params) {
          autocomplete = params.autocomplete
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
      }
      dispatch('apiGet', {url: '/users', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_SEARCH_FAILURE, res.data)
          } else {
            if (autocomplete) {
              commit(USER_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList})
            } else {
              commit(USER_SEARCH_SUCCESS, res.data)
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(USER_CLEAR)
      }, sleep)
    },
    [USER_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(USER_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },

    /** システム管理者 または 薬剤師確認 */
    [USER_ADMIN_PHARMACIST] ({dispatch, state, commit}, params) {
      var loadparams = false
      var data = null
      var callback = null

      state.userAdmin = false                    // システム管理者
      state.userPharmacist = false               // 薬剤師
      state.userPharmacistManager = false        // 組織長かつ薬剤師
      state.userAdminOrPharmacist = false        // システム管理者 または 薬剤師
      state.userAdminOrPharmacistManager = false // システム管理者 または 組織長かつ薬剤師
      state.userAdminOrPharmacistId = null       // システム管理者 または 薬剤師 ユーザーID
      state.userAdminOrPharmacistName = null     // システム管理者 または 薬剤師 ユーザー名

      if (params) {
        if ('data' in params) {
          data = params.data
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: '/users/admin_pharmacist', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_ADMIN_PHARMACIST_FAILURE, res.data)
          } else {
            commit(USER_ADMIN_PHARMACIST_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_SEARCH_FAILURE] (state, data) {
      console.log('USER_SEARCH_FAILURE')
    },
    [USER_SEARCH_SUCCESS] (state, data) {
      console.log('USER_SEARCH_SUCCESS')
      state.users = data.data
      if (data.meta && data.meta['next-page']) {
        state.usersNextPage = data.meta['next-page']
      }
    },
    [USER_CLEAR] (state) {
      state.users = []
    },
    [USER_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('USER_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.usersAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.usersAutocomplete === null) {
          state.usersAutocomplete = []
        }
        state.usersAutocomplete.unshift({'id': param.noneList['id'], 'type': 'users', 'attributes': {'user-name': param.noneList['name'], 'user-name-furigana': ''}})
      }
    },
    [USER_AUTOCOMPLETE_CLEAR] (state) {
      console.log('USER_AUTOCOMPLETE_CLEAR')
      state.usersAutocomplete = []
    },

    [USER_ADMIN_PHARMACIST_FAILURE] (state, data) {
      console.log('USER_ADMIN_PHARMACIST_FAILURE')
    },
    [USER_ADMIN_PHARMACIST_SUCCESS] (state, params) {
      console.log('USER_ADMIN_PHARMACIST_SUCCESS')
      state.userAdmin = params.data['admin']                                          // システム管理者
      state.userPharmacist = params.data['pharmacist']                                // 薬剤師
      state.userPharmacistManager = params.data['pharmacist_manager']                 // 組織長かつ薬剤師
      state.userAdminOrPharmacist = params.data['admin_or_pharmacist']                // システム管理者 または 薬剤師
      state.userAdminOrPharmacistManager = params.data['admin_or_pharmacist_manager'] // システム管理者 または 薬剤師
      state.userAdminOrPharmacistId = params.data['user_id']                          // システム管理者 または 薬剤師 ユーザーID
      state.userAdminOrPharmacistName = params.data['user_name']                      // システム管理者 または 薬剤師 ユーザー名

      if (params.callback !== null) {
        params.callback(params.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js